exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GZw8ddEV0LRTgWTC7qpJp {\n  margin: 0;\n  user-select: none;\n}\n\n._1GZw8ddEV0LRTgWTC7qpJp:hover {\n  background-color: #444444;\n}\n\n._20_IWSMqR831OtxHpDuM5U {\n  background-color: #666666;\n}\n\n.LPKCXpuSnN4iRDju8uk4n {\n  user-select: text;\n}\n", ""]);

// exports
exports.locals = {
	"line": "_1GZw8ddEV0LRTgWTC7qpJp",
	"lineHighlight": "_20_IWSMqR831OtxHpDuM5U",
	"lineSelectable": "LPKCXpuSnN4iRDju8uk4n"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./src/components/Line/index.module.css
// module id = 19
// module chunks = 0 1 2